import { EditorMultiText } from "./MultiText";
import { SelectorItem } from "./SelectorItem";
import { MediaContainer } from "./MediaContainer";
import { ImageItem } from "./ImageItem";
import { TextItem } from "./TextItem";
import { MultiTextHead } from "./MultiTextHead";
import { Div } from "../Div";
import { Img } from "../Img";
import { toMap } from "../../../../HA";

export class EditorMultiMedia extends EditorMultiText {

    public getSelections() {
        const data = [];
        this.getItems().forEach((s: SelectorItem) => {
            if (s.isChecked()) {
                data.push(s.getValue());
            }
        });

        return data;
    }

    protected getItems() {
        return this.getList().getItems();
    }

    protected getList() {
        return this.get("list");
    }

    protected addImageFiles(files: any[]) {
        for (const file of files) {
            this.addImageFile(file);
        }
        if (this.has("pfunc") && this.has("max") && files.length >= this.get("max")) {
            this.get("pfunc").itemClick(this.getSelections());
        }
    }

    protected addImageFile(file: any) {
        if (file && !this.getList().hasValue(file.name)) {
            const imgContainer = new MediaContainer(toMap({f: file}));
            const div = new Div({className: "thumb"});
            div.appendChild(new Img(toMap({f: file})));
            imgContainer.appendChild(div);
            this.getList().addItem(new ImageItem(toMap({item: imgContainer, s: true})));
        }
    }

    protected createItem(data: any) {
        return new TextItem(data);
    }

    protected createHead(data?: any) {
        return new MultiTextHead(toMap({
            accept: this.get("encodings") || "image/x-png,image/gif,image/jpeg,image/svg+xml",
            ed: {
                addImageFile: (file: any) => {
                    if (file) {
                        this.addImageFile(file);
                    }
                },
                addImageFiles: (files?: any[]) => {
                    if (files) {
                        this.addImageFiles(files);
                    }
                },
            },
            max: this.get("max"),
            t: this.get("t") || "img/url",
            tc: this.get("tc"),
        }));
    }
}
